export declare function compare(dom: string | HTMLElement): void;
export default compare;
